import { figmaSemanticColors, figmaSemanticColorsDark } from '../tokens';
import type { SemanticColors } from '../tokens';

export type { SemanticColors } from '../tokens';

export type Appearance = 'light' | 'dark';

export const semanticColorsByAppearance: Record<Appearance, SemanticColors> = {
  light: figmaSemanticColors,
  dark: figmaSemanticColorsDark,
};

export const resolveSemanticColors = (appearance: Appearance): SemanticColors => semanticColorsByAppearance[appearance];
